import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@material-ui/core"
import { isEmpty } from "lodash"
import { observer } from "mobx-react"
import { useContext, useEffect, useRef, useState } from "react"
import SentimentQuestionIcon from "~/assets/Icons/sentiment-icon.svg?react"
import Content from "~/components/Questions/Content"
import Sidebar from "~/components/Questions/Sidebar"
import { Sentiment } from "~/components/Questions/models/Question"
import SentimentQuestions from "~/components/Questions/models/SentimentQuestions"
import App from "~/contexts/App"
import usePrevious from "~/hooks/usePrevious"

import Box from "../../../components/Common/Box"
import DialogTitle from "../components/DialogTitle"
import useStyles from "./styles"

const questionTypes = [
  {
    name: "Multiple Choice",
    model: Sentiment,
    type: "multiple_choice",
  },
]

const SentimentQuestionsEditorDialog = () => {
  const scrollAreaRef = useRef()
  const [store, setStore] = useState({})

  const classes = useStyles()

  const { dialogs, closeDialog } = useContext(App)
  const thisDialog = dialogs?.["sentimentQuestionsEditor"] || {}
  const { open = false, data = {} } = thisDialog
  const { learningCueId, ...sentimentQuestionsData } = data
  const { lockdown, startSeconds, questions, ...restData } =
    sentimentQuestionsData

  const setLocalState = () => {
    let newSentimentQuestion
    if (!isEmpty(questions)) {
      newSentimentQuestion = SentimentQuestions.create({
        questions: questions.map((q) => {
          const questionType = questionTypes.find((t) => t.type === q.type)
          if (questionType) {
            return questionType.model.create(q)
          } else {
            return questionTypes
              .find((t) => t.type === "multiple_choice")
              .model.create(q)
          }
        }),
      })
    } else {
      newSentimentQuestion = SentimentQuestions.create()
    }
    setStore(newSentimentQuestion)
  }

  const [showErrors, setShowErrors] = useState(false)

  const handleClose = () => {
    closeDialog("sentimentQuestionsEditor")
  }

  const handleSave = () => {
    if (!store?.isValid) {
      setShowErrors(true)
    } else {
      setShowErrors(false)
      closeDialog("sentimentQuestionsEditor", true, store.toJSON())
    }
  }

  const handleRemove = () => {
    closeDialog("sentimentQuestionsEditor", true, undefined)
  }

  const previousQuestionsLength = usePrevious(store?.questions?.length || 0)

  useEffect(() => {
    if (
      store?.questions?.length > previousQuestionsLength &&
      previousQuestionsLength !== 0
    ) {
      const lastQuestionId = store.questions[store.questions.length - 1].id
      // animateScrollTo(
      //   document.querySelector(`#question-id-${lastQuestionId}`),
      //   {
      //     elementToScroll: scrollAreaRef.current,
      //   }
      // )
    }
  }, [previousQuestionsLength, store?.questions?.length])

  return (
    <Dialog
      TransitionProps={{ onEntering: setLocalState }}
      open={open}
      onClose={handleClose}
      classes={{
        paperWidthSm: classes.dialogContainer,
      }}
    >
      <DialogTitle
        title="Add Sentiment Questions"
        icon={
          <SentimentQuestionIcon
            style={{
              position: "relative",
              top: 3,
              marginLeft: 10,
              color: "rgb(255 31 31)",
              height: 21,
            }}
          />
        }
        disableTypography
        timestamp={startSeconds}
      />
      <DialogContent className={classes.dialogContent}>
        <Sidebar
          lockdown={lockdown}
          questionTypes={questionTypes}
          store={store}
        />
        <Box
          paddingLeft="20px"
          paddingRight="16px"
          flexGrow="1"
          overflow="auto"
          ref={scrollAreaRef}
        >
          {store?.questions?.length === 0 && (
            <Box
              display="flex"
              justifyContent="center"
              height="100%"
              alignItems="center"
            >
              <Typography>
                Click a question on the left to add at least one question to
                this set of Sentiment Questions
              </Typography>
            </Box>
          )}
          {store?.questions?.map?.((question) => (
            <Content
              key={question}
              question={question}
              showingErrors={showErrors}
              lockdown={lockdown}
              isSentiment
              usesAttempts={false}
            />
          ))}
        </Box>
      </DialogContent>
      <DialogActions style={{ justifyContent: "space-between" }}>
        <Box>
          {!isEmpty(restData) && (
            <Button
              className={classes.removeButton}
              onClick={handleRemove}
              type="button"
              size="small"
              disabled={lockdown}
            >
              Remove
            </Button>
          )}
        </Box>
        <Box>
          <Button
            onClick={handleClose}
            type="button"
            style={{ marginRight: "2vw" }}
          >
            Close
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSave}
            disabled={lockdown}
          >
            Done
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default observer(SentimentQuestionsEditorDialog)
